import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormV2Template } from './form-v2-template'

export class FormV2TemplatesRepository extends BaseRepository<FormV2Template> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/forms-v2/templates', token, cache)
    }

    // "content" é a data URL completa ("data:<mime>;base64,<dados>") — mesma convenção de upload
    // já usada no projeto (ver FilesService.uploadToSignedLink). Não usa multipart/FormData: o
    // Request compartilhado só manda JSON.
    async generateFromFile(dto: { filename: string; content: string }) {
        const { json, statusCode, message } = await this.request.post(this.url + '/generate-from-file?token=' + this.resolvedToken, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
